import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';

import { Button } from 'components/ui/button';
import Modal from 'components/modal';

import './styles.scss';

const AutoCalcToggleModal = ({
  handleToggleChange,
  isToggleChecked,
  show,
  onHide,
}) => {
  const onConfirm = () => {
    handleToggleChange(!isToggleChecked);
    onHide();
  };

  return (
    <Modal className="visible-overflow auto-calc-modal" show={show} onHide={() => onHide()}>
      <Modal.Header closeButton>Warning</Modal.Header>

      <Modal.Body>
        <div className="d-flex flex-column">
          <FontAwesomeIcon
            className="align-self-center icon-warning"
            icon={faCircleExclamation}
            size="4x"
          />
          <div className="mt-4">
            {isToggleChecked ? (
              <div name="disable-copy">
                <p>
                  Disabling this setting will turn off auto-calculations for the{' '}
                  <strong>Lease Rate</strong> and <strong>Total Rent</strong> in
                  each of the individual lease terms.
                </p>
                <p>
                  Adjusting the <strong>Start Date</strong>,{' '}
                  <strong>End Date</strong> or <strong>Months</strong> for a
                  particular term will not update <strong>Lease Rate</strong> or{' '}
                  <strong>Total Rent</strong> automatically.
                </p>
                <p>
                  <strong>Commission</strong> amounts and grand totals for the
                  full lease will still be auto-calculated.
                </p>
              </div>
            ) : (
              <p name="enable-copy">
                Enabling this setting may re-calculate and overwrite <strong>Total Rent</strong>{' '}
                and <strong>Commission</strong> amounts.
              </p>
            )}
            <p>Are you sure you want to continue?</p>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button label="Cancel" variant="ghost" onClick={onHide} />
        <Button label="Yes, Continue" onClick={onConfirm} />
      </Modal.Footer>
    </Modal>
  );
};

AutoCalcToggleModal.propTypes = {
  handleToggleChange: PropTypes.func.isRequired,
  isToggleChecked: PropTypes.bool,
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
};

export default AutoCalcToggleModal;
